import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import socketService from "../socket/newsocketService";
import apiClient from "./apiClient";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { getDatabase, ref, onValue, remove, update } from "firebase/database";
import { useDispatch } from "react-redux";
import { addChatWindow } from "../Redux/Slice/dataSlice";
import SendMessageModal from "./SendMessageModal";
import DialogBox from "DialogBox/DialogBox";

const normalizeEscortCollection = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === "object") {
    return Object.values(value);
  }

  return [];
};

export default function LongMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [pushNotificationOptions, setPushNotificationOptions] = useState([]);
  const [openSendMessage, setOpenMessage] = useState(false);
  const [openGsmModal, setOpenGsmModal] = useState(false);

  //console.log("props", props?.props?.gsmMode);

  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const options = [
    "Check Arrival",
    "Send Push Notification",
    ...(props?.virtualTravelGuard
      ? ["Delete Virtual Escort"]
      : props?.VitualWellBeingHomeCheck
        ? ["Delete Virtual Home Check"]
        : ["Delete Escort"]),

    "Dispatch Security",
    "Send E-Mail",
    "Lets chat",
    "Send Message",

    ...(props?.VitualWellBeingHomeCheck ? ["Location Address"] : []),

    ...(props?.props?.gsmMode ? ["SDE (GSM MODE MODAL)"] : []),
    "Show Notification",
  ];

  useEffect(() => {
    const db = getDatabase();
    const dbRef = ref(db, "pushnotification");

    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setPushNotificationOptions(
          Object.entries(data).map(([key, value]) => ({ id: key, ...value }))
        );
      }
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (index) => {
    const selectedOption = options[index];

    const userId = props?.props?.userId || props?.props?.id;

    if (selectedOption === "Check Arrival") {
      const nowMs = Date.now();
      console.log("[Escort][socket] emit sendcustompushnotification", {
        userId,
        action: "arrivalcheck",
        title: "Check Arrival",
      });
      socketService.emit("sendcustompushnotification", {
        userId,
        title: "Check Arrival",
        message: "Please Confirm Arrival at this Location",
        action: "arrivalcheck",
        source: "escort",
        fromEscort: "true",
        vibrate: true,
      });

      socketService.emit("manual_wellbeing_check", {
        userId,
        action: "arrivalcheck",
        title: "Check Arrival",
        message: "Please Confirm Arrival at this Location",
        source: "escort",
        fromEscort: "true",
        vibrate: true,
      });

      if (userId) {
        try {
          const db = getDatabase();
          update(ref(db, `users/${userId}`), {
            Wellbeing_Response: "Awaiting Response",
            wellbeingResponse: "Awaiting Response",
            wellbeingCheckSource: "Sent by Escort Staff",
            wellbeingSentAt: nowMs,
            wellbeingPushStatus: "Delivered",
            userFBK: null,
            userFeedback: null,
            feedback: null,
          });
          localStorage.setItem(`wb_sent_${userId}`, String(nowMs));
          localStorage.setItem(`wb_awaiting_${userId}`, String(nowMs));
          localStorage.removeItem(`wb_resp_dur_${userId}`);
        } catch (e) {
          console.warn("Firebase update notice:", e);
        }
      }

      toast.info("Requested feedback from the user");
    }

    if (selectedOption === "Send Push Notification") {
      setOpenModal(true);
    }

    if (
      selectedOption === "Delete Escort" ||
      selectedOption === "Delete Virtual Home Check" ||
      selectedOption === "Delete Virtual Escort"
    ) {
      const db = getDatabase();

      if (selectedOption === "Delete Virtual Escort") {
        const virtualId = props?.virtualId;
        const userIdLocal = props?.props?.userId;

        if (!virtualId || !userIdLocal) {
          toast.error("Missing Virtual Escort Key");
          return;
        }

        const db = getDatabase();

        const userTourRef = ref(db, `users/${userIdLocal}`);
        const escortTourRef = ref(db, `users/${userIdLocal}/wellBeingServicesData/${virtualId}`);

        update(userTourRef, { tour: false })
          .then(() => {
            return update(escortTourRef, { tour: false });
          })
          .then(() => {
            if (typeof window !== "undefined") {
              window.dispatchEvent(
                new CustomEvent("stopEscortVoice", {
                  detail: { userId: userIdLocal, virtualId, action: "endvirtualescort" },
                })
              );
              if ("speechSynthesis" in window) {
                window.speechSynthesis.cancel();
              }
            }
            toast.info("VirtualTravelGuard Ended");
          })
          .catch((err) => toast.error(err.message));

        setAnchorEl(null);
        return;
      }

      if (selectedOption === "Delete Virtual Home Check") {
        const virtualId = props?.virtualId;
        if (!virtualId) {
          toast.error("Missing Virtual Home Check ID");
          return;
        }

        const virtualRef = ref(db, `/virtualhomecheck/${virtualId}`);

        remove(virtualRef)
          .then(() => toast.info("Virtual Home Check deleted"))
          .catch((err) => toast.error(err.message));

        setAnchorEl(null);
        return;
      }

      if (selectedOption === "Delete Escort") {
        const resolvedUserId =
          props?.props?.userId ||
          props?.props?.id ||
          props?.props?._id?.toString?.() ||
          props?.props?._id;

        if (!resolvedUserId) {
          toast.error("Missing user id for escort history update");
          setAnchorEl(null);
          return;
        }

        try {
          const userResponse = await apiClient.get(`/users/${resolvedUserId}`);
          const userData = userResponse?.data || userResponse?.data?.data || userResponse || {};
          const escortEntries = normalizeEscortCollection(userData?.ShortDistance_Escort);
          const latestEscortIndex = escortEntries.length - 1;

          if (latestEscortIndex >= 0) {
            const endedAt = Date.now();
            const adminInfo = JSON.parse(localStorage.getItem("user") || "{}");
            const updatedEscortEntries = [...escortEntries];

            updatedEscortEntries[latestEscortIndex] = {
              ...updatedEscortEntries[latestEscortIndex],
              Trip_Status: "Ended",
              escortStatus: "ended",
              escortActive: false,
              ended: true,
              tripendtime: endedAt,
              escortEndedAt: endedAt,
              endedByAdminId:
                adminInfo?.userId || adminInfo?.id || adminInfo?._id?.toString?.() || null,
              endedByAdminName: adminInfo?.name || adminInfo?.userName || "Admin",
            };

            await apiClient.put(`/users/${resolvedUserId}`, {
              ShortDistance_Escort: updatedEscortEntries,
              latestEscort: updatedEscortEntries[latestEscortIndex],
            });
          }

          console.log("[Escort][socket] emit endescort", {
            userId: resolvedUserId,
          });
          socketService.emit("endescort", { userId: resolvedUserId });
          if (typeof window !== "undefined") {
            window.dispatchEvent(
              new CustomEvent("stopEscortVoice", {
                detail: { userId: resolvedUserId, action: "endescort" },
              })
            );
            if ("speechSynthesis" in window) {
              window.speechSynthesis.cancel();
            }
          }
          toast.info("Escort ended and saved to history");
        } catch (error) {
          console.error("[Escort] failed to persist ended escort history", error);
          toast.error(error?.message || "Failed to save escort history before ending");
        }
        setAnchorEl(null);
      }
    }

    if (selectedOption === "Dispatch Security") {
      const userPayload = props?.props?.userData || props?.props;

      let payload = {
        alert_type: "Emergency",
        alert_message: "A user needs emergency service",
        Latitude: userPayload?.currentLat,
        Longitude: userPayload?.currentLong,
        isRead: true,
        user_Img: userPayload?.userImage,
        user_Name: userPayload?.userName,
        user_Phone: userPayload?.userPhone,
        timestamp: userPayload?.currentTimeStamp,
        userId,
      };

      console.log("[Escort][socket] emit sendalert", {
        userId,
        payload,
      });
      socketService.emit("sendalert", { payload, isBroadcast: false });
      toast.info("Security dispatched");
    }

    if (selectedOption === "Send E-Mail") {
      console.log("[Escort][socket] emit sendemail", {
        userId,
      });
      socketService.emit("sendemail", { userId });
      toast.info("Email sent successfully");
    }

    if (selectedOption === "Lets chat") {
      const username = props?.props?.userData?.userName;
      dispatch(addChatWindow({ userId, username }));
    }

    if (selectedOption === "Send Message") {
      setOpenMessage(true);
    }

    if (selectedOption === "Location Address") {
      const Place = props?.props?.Place;
      if (Place) {
        const [lat, lng] = Place.split(",").map((v) => v.trim());
        window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
      }
    }

    if (selectedOption === "SDE (GSM MODE MODAL)") {
      setOpenGsmModal(true);
      setAnchorEl(null);
      return;
    }

    if (selectedOption === "Show Notification") {
      const lastEscort = props?.getLastEscort?.(props?.props?.userData?.ShortDistance_Escort);

      const notifications = lastEscort?.notifications
        ? props?.getSortedNotifications?.(lastEscort.notifications)
        : [];

      props?.onShowNotification?.(notifications);
      setAnchorEl(null);
      return;
    }

    setAnchorEl(null);
  };

  const handleSendPushNotification = () => {
    const userId = props?.props?.userId || props?.props?.id;
    const selectedOption = pushNotificationOptions.find(o => (o.id && o.id === dropdownValue) || o.title === dropdownValue || o.action === dropdownValue);
    const actionVal = selectedOption?.action || dropdownValue || "notification";
    const titleVal = selectedOption?.title || "Notification";
    const msgVal = selectedOption?.body || selectedOption?.message || "You have a new alert";
    const nowMs = Date.now();
    
    console.log("[Escort][socket] emit pushnotificationevent", {
      userId,
      action: actionVal,
    });
    
    socketService.emit("pushnotificationevent", { userId, action: actionVal });
    
    // Also emit sendcustompushnotification to ensure the Firebase push notification is actually sent
    socketService.emit("sendcustompushnotification", {
      userId,
      action: actionVal,
      title: titleVal,
      message: msgVal,
      source: "escort",
      fromEscort: "true",
      vibrate: true,
    });

    const isWellbeingAction = actionVal === "wellbeingcheck" || String(actionVal).toLowerCase().includes("wellbeing");
    if (isWellbeingAction) {
      socketService.emit("manual_wellbeing_check", {
        userId,
        action: actionVal,
        title: titleVal,
        message: msgVal,
        source: "escort",
        fromEscort: "true",
        vibrate: true,
      });

      if (userId) {
        try {
          const db = getDatabase();
          update(ref(db, `users/${userId}`), {
            Wellbeing_Response: "Awaiting Response",
            wellbeingResponse: "Awaiting Response",
            wellbeingCheckSource: "Sent by Escort Staff",
            wellbeingSentAt: nowMs,
            wellbeingPushStatus: "Delivered",
            userFBK: null,
            userFeedback: null,
            feedback: null,
          });
          localStorage.setItem(`wb_sent_${userId}`, String(nowMs));
          localStorage.setItem(`wb_awaiting_${userId}`, String(nowMs));
          localStorage.removeItem(`wb_resp_dur_${userId}`);
        } catch (e) {
          console.warn("Firebase update notice:", e);
        }
      }
    }

    toast.info(isWellbeingAction ? "Wellbeing Check Sent and response timer started" : "Push Notification Sent");
    setOpenModal(false);
  };

  return (
    <>
      {openModal && (
        <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
          <DialogTitle>Send Push Notification</DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel>Select Option</InputLabel>
              <Select
                value={dropdownValue}
                label="Select Option"
                onChange={(e) => setDropdownValue(e.target.value)}
                style={{ width: "100%", height: 50 }}
              >
                {pushNotificationOptions.length > 0 ? (
                  pushNotificationOptions.map((option, index) => (
                    <MuiMenuItem key={option.id || index} value={option.id || option.title || option.action}>
                      {option.title}
                    </MuiMenuItem>
                  ))
                ) : (
                  <MuiMenuItem>No Options Available</MuiMenuItem>
                )}
              </Select>
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenModal(false)}>Cancel</Button>
            <Button onClick={handleSendPushNotification}>Send</Button>
          </DialogActions>
        </Dialog>
      )}

      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {options.map((option, index) => (
          <MenuItem key={index} onClick={() => handleClose(index)}>
            {option}
          </MenuItem>
        ))}
      </Menu>

      <SendMessageModal
        visible={openSendMessage}
        onClose={() => setOpenMessage(false)}
        userData={props?.props?.userData}
      />

      <DialogBox
        userInfo={props?.props?.userData || props?.props}
        open={openGsmModal}
        onClose={() => setOpenGsmModal(false)}
      />
    </>
  );
}
